/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Modified by PragmaFlow, Inc for OrangeDAO to be used in Noodl
 *
 */

// import './OrangeDAOTheme.css';

export const OrangeDAOTheme = {
  blockCursor: 'OrangeDAOTheme__blockCursor',
  characterLimit: 'OrangeDAOTheme__characterLimit',
  code: 'OrangeDAOTheme__code',
  codeHighlight: {
    atrule: 'OrangeDAOTheme__tokenAttr',
    attr: 'OrangeDAOTheme__tokenAttr',
    boolean: 'OrangeDAOTheme__tokenProperty',
    builtin: 'OrangeDAOTheme__tokenSelector',
    cdata: 'OrangeDAOTheme__tokenComment',
    char: 'OrangeDAOTheme__tokenSelector',
    class: 'OrangeDAOTheme__tokenFunction',
    'class-name': 'OrangeDAOTheme__tokenFunction',
    comment: 'OrangeDAOTheme__tokenComment',
    constant: 'OrangeDAOTheme__tokenProperty',
    deleted: 'OrangeDAOTheme__tokenProperty',
    doctype: 'OrangeDAOTheme__tokenComment',
    entity: 'OrangeDAOTheme__tokenOperator',
    function: 'OrangeDAOTheme__tokenFunction',
    important: 'OrangeDAOTheme__tokenVariable',
    inserted: 'OrangeDAOTheme__tokenSelector',
    keyword: 'OrangeDAOTheme__tokenAttr',
    namespace: 'OrangeDAOTheme__tokenVariable',
    number: 'OrangeDAOTheme__tokenProperty',
    operator: 'OrangeDAOTheme__tokenOperator',
    prolog: 'OrangeDAOTheme__tokenComment',
    property: 'OrangeDAOTheme__tokenProperty',
    punctuation: 'OrangeDAOTheme__tokenPunctuation',
    regex: 'OrangeDAOTheme__tokenVariable',
    selector: 'OrangeDAOTheme__tokenSelector',
    string: 'OrangeDAOTheme__tokenSelector',
    symbol: 'OrangeDAOTheme__tokenProperty',
    tag: 'OrangeDAOTheme__tokenProperty',
    url: 'OrangeDAOTheme__tokenOperator',
    variable: 'OrangeDAOTheme__tokenVariable',
  },
  embedBlock: {
    base: 'OrangeDAOTheme__embedBlock',
    focus: 'OrangeDAOTheme__embedBlockFocus',
  },
  hashtag: 'OrangeDAOTheme__hashtag',
  heading: {
    h1: 'OrangeDAOTheme__h1',
    h2: 'OrangeDAOTheme__h2',
    h3: 'OrangeDAOTheme__h3',
    h4: 'OrangeDAOTheme__h4',
    h5: 'OrangeDAOTheme__h5',
    h6: 'OrangeDAOTheme__h6',
  },
  image: 'editor-image',
  indent: 'OrangeDAOTheme__indent',
  link: 'OrangeDAOTheme__link',
  list: {
    listitem: 'OrangeDAOTheme__listItem',
    listitemChecked: 'OrangeDAOTheme__listItemChecked',
    listitemUnchecked: 'OrangeDAOTheme__listItemUnchecked',
    nested: {
      listitem: 'OrangeDAOTheme__nestedListItem',
    },
    olDepth: [
      'OrangeDAOTheme__ol1',
      'OrangeDAOTheme__ol2',
      'OrangeDAOTheme__ol3',
      'OrangeDAOTheme__ol4',
      'OrangeDAOTheme__ol5',
    ],
    ul: 'OrangeDAOTheme__ul',
  },
  ltr: 'OrangeDAOTheme__ltr',
  mark: 'OrangeDAOTheme__mark',
  markOverlap: 'OrangeDAOTheme__markOverlap',
  paragraph: 'OrangeDAOTheme__paragraph',
  quote: 'OrangeDAOTheme__quote',
  rtl: 'OrangeDAOTheme__rtl',
  table: 'OrangeDAOTheme__table',
  tableAddColumns: 'OrangeDAOTheme__tableAddColumns',
  tableAddRows: 'OrangeDAOTheme__tableAddRows',
  tableCell: 'OrangeDAOTheme__tableCell',
  tableCellActionButton: 'OrangeDAOTheme__tableCellActionButton',
  tableCellActionButtonContainer:
    'OrangeDAOTheme__tableCellActionButtonContainer',
  tableCellEditing: 'OrangeDAOTheme__tableCellEditing',
  tableCellHeader: 'OrangeDAOTheme__tableCellHeader',
  tableCellPrimarySelected: 'OrangeDAOTheme__tableCellPrimarySelected',
  tableCellResizer: 'OrangeDAOTheme__tableCellResizer',
  tableCellSelected: 'OrangeDAOTheme__tableCellSelected',
  tableCellSortedIndicator: 'OrangeDAOTheme__tableCellSortedIndicator',
  tableResizeRuler: 'OrangeDAOTheme__tableCellResizeRuler',
  tableSelected: 'OrangeDAOTheme__tableSelected',
  text: {
    bold: 'OrangeDAOTheme__textBold',
    code: 'OrangeDAOTheme__textCode',
    italic: 'OrangeDAOTheme__textItalic',
    strikethrough: 'OrangeDAOTheme__textStrikethrough',
    subscript: 'OrangeDAOTheme__textSubscript',
    superscript: 'OrangeDAOTheme__textSuperscript',
    underline: 'OrangeDAOTheme__textUnderline',
    underlineStrikethrough: 'OrangeDAOTheme__textUnderlineStrikethrough',
  },
};